















import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { Toast } from '@/store/modules/status'

@Component<Toasts>({})
export default class Toasts extends Vue {
    @Prop({ type: Array, required: true })
    public readonly toasts!: Toast[]

    public removeToast(toastId) {
        this.$emit('removeToast', toastId)
    }
}
